<template lang="html">
  <div class="prod-body" ref="wrap">
    <div class="prod-head" 
        data-aos="fade-up"
        data-aos-duration="1000">
      <div class="prod-img">
        <div class="prod-opacity">
        </div>
      </div>
      <div class="prod-intro">
        <h2 v-html="$t('message.beads_title')" ></h2>
        <div class="prod-intro-text">
          <p v-html="$t('message.beads_intro')"></p>
        </div>
      </div>
    </div>
    <div class="prod-accordions-wrap" >
      <AccordionMain 
        v-for="(accordions, index) in $t('message.beads_main_accordions') " :key="index"
        :content="$t('message.beads_main_accordions')[index]"
        data-aos="fade-up"
        data-aos-duration="1000"
        />
    </div>
  </div>
</template>

<script>
import AccordionMain from "../components/shared/AccordionMain.vue";
import imagesLoaded from "imagesloaded";

export default {
  name: "Beams",
  components: {
    AccordionMain,
  },
  mounted() {
    // Preload images
    let imagestoLoad = this.$refs.wrap.querySelectorAll("img");

    for (var i = 0; i < imagestoLoad.length; i++) {
      imagestoLoad[i].classList.add("blur");
    }
    const preloadImages = () => {
      return new Promise((resolve, reject) => {
        imagesLoaded(imagestoLoad, resolve);
      });
    };

    // And then..
    preloadImages().then(() => {
      // Remove the loader
      for (var i = 0; i < imagestoLoad.length; i++) {
        imagestoLoad[i].classList.remove("blur");
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.prod-body {
  position: relative;
  width: 100%;
  top: 0;
}
.prod-head {
  position: relative;
  width: 100%;
  .prod-img {
    position: absolute;
    width: 100%;
    height: 250px;
    z-index: 1;
    top: 0;
    left: 0;
    background-image: url("../assets/images/11_2x.jpg");
  }
  .prod-opacity {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 2;
    height: 250px;
    background-color: rgba($color: #000000, $alpha: 0.3);
  }
  .prod-intro {
    position: relative;
    padding-top: 50px;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    h2 {
      font-size: 60px;
      line-height: 74px;
      color: #fff;
      text-align: center;
      padding: 0 20px;
      margin-bottom: 40px;
      @media screen and (max-width: 900px) {
        font-size: 40px;
        line-height: 50px;
      }
    }
    .prod-intro-text {
      width: 60%;
      margin: 0 auto;
      background-color: #fff;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
      border-radius: 4px;
      @media screen and (max-width: 900px) {
        width: 90%;
      }
    }
    p {
      font-size: 16px;
      line-height: 28px;
      color: #33586e;
      margin: 50px auto;
      width: 80%;
      text-align: center;
      @media screen and (max-width: 900px) {
        font-size: 12px;
        width: auto;
        padding: 0 20px;
        line-height: 24px;
      }
    }
  }
}
.prod-accordions-wrap {
  position: relative;
  padding: 150px 120px 0;
  overflow: hidden;
  @media screen and (max-width: 1100px) {
    padding: 150px 60px 0;
  }
  @media screen and (max-width: 900px) {
    padding: 80px 20px 0;
  }
}
</style>



// WEBPACK FOOTER //
// Beads.vue?4786eb90